// components/CTHeader.jsx
import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMainState } from "contexts/MainStateContext";
import { useTheme } from "contexts/ThemeContext";
import { useUser } from "contexts/UserContext";
import CTButton from "./CTButton";
import CTSwitch from "./CTSwitch";
import CTEdit from "./CTEdit";
import Icono from "./CTIcons";

const CTHeader = ({ onToggleSidebar, onConfigClick, variant = "default" }) => {
  const { theme, setTheme } = useTheme();
  const { user, logoutUser } = useUser();
  const navigate = useNavigate();
  const { setMainState } = useMainState();
  const [searchValue, setSearchValue] = useState("");

  const title = user?.appDes || "Mi ERP";

  const handleLogout = useCallback(() => {
    setMainState((prev) => ({ ...prev, dynamicContent: null }));
    logoutUser();
    navigate("/login", { replace: true });
  }, [logoutUser, navigate, setMainState]);

    // Toggle Right Menu
    const toggleRightMenu = useCallback(() => {
      setMainState((prev) => ({
        ...prev,
        showRightMenu: !prev.showRightMenu,
      }));
    }, [setMainState]);

  const handleToggleTheme = (checked) => setTheme(checked ? "dark" : "light");

  const handleSearchChange = (val) => setSearchValue(val);
  const handleSearchEnter = (val) => alert(`Buscar: ${val}`);

const PngIcon = ({ size }) => (
  <img
    src="/favicon.png"
    alt="menu"
    style={{ width: size, height: size }}
  />
);


  return (
    <header className={`ctheader ctheader-${variant} w-full flex items-center justify-between px-4 py-2 shadow-md`}>
      
      {/* Izquierda: hamburguesa + título */}
      <div className="flex items-center gap-2">
        <CTButton
           icon={PngIcon}
          onClick={onToggleSidebar}
          variant="secondary"
          iconPosition="top"
          iconSize={20}
        />
        <h1 className="ctheader-title font-bold text-lg">{title}</h1>
      </div>

      {/* Centro: CTEdit como buscador */}
      <div className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg">
        <CTEdit
          label=""
          iconIndex={9}        // <- MdSearch
          name="headerSearch"
          value={searchValue}
          onChange={handleSearchChange}
          placeholder="Buscar..."
          isEditable
        />
      </div>

      {/* Derecha: acciones */}
      <div className="flex items-center gap-2">
        {/* Switch tema */}
        <CTSwitch
          checked={theme === "dark"}
          onChange={handleToggleTheme}
          label=""
          size="lg"
        />

        {/* Notificaciones */}
        <CTButton
          iconIndex={5} // correo/mensajes
          onClick={() => alert("Notificaciones")}
          variant="secondary"
          iconSize={20}
        />

        {/* Perfil usuario */}
        <CTButton
          iconIndex={4} // usuario
          onClick={ toggleRightMenu}
          variant="secondary"
          iconSize={20}
        />

        {/* Configuración */}
        {onConfigClick && (
          <CTButton
            iconIndex={2} // engranaje
            onClick={onConfigClick}
            variant="secondary"
            iconSize={20}
          />
        )}

        {/* Logout */}
        <CTButton
          iconIndex={14}
          onClick={handleLogout}
          variant="secondary"
          iconSize={20}
        />
      </div>
    </header>
  );
};

export default CTHeader;
